var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4 section-sub-heading"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }